import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './styles.scss'

class Counter extends Component {
    formatter = count =>
        count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, this.props.thousandSeparator)

    renderCounterNumber = () => {
        const number = this.formatter(this.props.count)
        return <span className={styles.counterNumber}>{number}</span>
    }

    renderCounterText = () => {
        let text = this.props.counterTextPlural
        if (Math.floor(this.props.count) === 1) {
            text = this.props.counterTextSingular
        }

        let counterText = null
        if (text != null) {
            counterText = <span className={styles.counterText}>{text}</span>
        }

        return counterText
    }

    renderCounterAndText = () => {
        // Get the number of players
        const counterNumber = this.renderCounterNumber()

        // Get the text for players
        const counterText = this.renderCounterText()

        // If we are currently using a locale that wants to display
        // players text in front of number, return the correct order
        if (this.props.textFirst) {
            return (
                <span className={styles.container}>
                    {counterText}
                    {counterNumber}
                </span>
            )
        }

        // All other languages default to number first
        return (
            <span className={styles.container}>
                {counterNumber}
                {counterText}
            </span>
        )
    }

    render() {
        return this.renderCounterAndText()
    }
}

Counter.propTypes = {
    count: PropTypes.number,
    textFirst: PropTypes.bool,
    thousandSeparator: PropTypes.string,
    counterTextSingular: PropTypes.string,
    counterTextPlural: PropTypes.string,
}

export default Counter



// WEBPACK FOOTER //
// ./src/features/ServerMenu/components/Menu/components/AnimatedCounter/Counter/component.js